module.exports = __webpack_public_path__ + "img/official_document_convention.bba05a12.svg";